const elements = require('./elements');
const channels = require('./channels');

// @TODO This really could be cleaned up, and all the port numbers moved to the elements config files.. I don't think theres
// any need to have them defined here like this, except to maybe create the combinations down below. The following could
// still be dynamically generated, except rather then defining a port number in here, we simply read it from element config
// Might make it tricky to add new elements thought..
const portsByElement = {
  [elements.BLOSSOMS_1.id]: { [channels.CONST__CH_1]: 101, [channels.CONST__CH_2]: null },
  [elements.BLOSSOMS_2.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: 102 },
  [elements.BLOSSOMS_3.id]: { [channels.CONST__CH_1]: 99, [channels.CONST__CH_2]: null },
  [elements.BLOSSOMS_4.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: 100 },

  [elements.SANTA_REINDEER.id]: { [channels.CONST__CH_1]: [85, 89], [channels.CONST__CH_2]: [86, 87] },
  [elements.SANTA_SLEIGH.id]: { [channels.CONST__CH_1]: 85, [channels.CONST__CH_2]: null },
  [elements.SANTA_HAND.id]: { [channels.CONST__CH_1]: 89, [channels.CONST__CH_2]: 90 },
  [elements.REINDEER_SLEIGH.id]: { [channels.CONST__CH_1]: 86, [channels.CONST__CH_2]: null },
  [elements.REINDEER_LEGS.id]: { [channels.CONST__CH_1]: 87, [channels.CONST__CH_2]: 88 },
  [elements.HOLLY.id]: { [channels.CONST__CH_1]: 61, [channels.CONST__CH_2]: 62 },
  [elements.SNOWFLAKE_ICE_1.id]: { [channels.CONST__CH_1]: 123, [channels.CONST__CH_2]: 124 },
  [elements.SNOWFLAKE_ICE_2.id]: { [channels.CONST__CH_1]: 125, [channels.CONST__CH_2]: 126 },
  [elements.NEON_SNOWFLAKE_1.id]: { [channels.CONST__CH_1]: 117, [channels.CONST__CH_2]: 118 },
  [elements.NEON_SNOWFLAKE_2.id]: { [channels.CONST__CH_1]: 119, [channels.CONST__CH_2]: 120 },
  [elements.SIMPLE_SNOWFLAKES.id]: { [channels.CONST__CH_1]: 121, [channels.CONST__CH_2]: 122 },
  [elements.KANGAROO_LOW.id]: { [channels.CONST__CH_1]: 182, [channels.CONST__CH_2]: null },
  [elements.KANGAROO_HIGH.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: 181 },
  [elements.KOALA.id]: { [channels.CONST__CH_1]: 73, [channels.CONST__CH_2]: 74 },
  [elements.ROPELIGHT_W.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },

  [elements.REINDEER_BUCKY_CW.id]: { [channels.CONST__CH_1]: 211, [channels.CONST__CH_2]: 212 },
  [elements.REINDEER_BUCKY_WW.id]: { [channels.CONST__CH_1]: 213, [channels.CONST__CH_2]: 214 },
  [elements.REINDEER_BUCKY_MULTI.id]: { [channels.CONST__CH_1]: 215, [channels.CONST__CH_2]: 216 },
  [elements.REINDEER_JO_CW.id]: { [channels.CONST__CH_1]: 217, [channels.CONST__CH_2]: 218 },
  [elements.REINDEER_JO_WW.id]: { [channels.CONST__CH_1]: 221, [channels.CONST__CH_2]: 222 },
  [elements.REINDEER_JO_MULTI.id]: { [channels.CONST__CH_1]: 219, [channels.CONST__CH_2]: 220 },
  [elements.REINDEER_JANE_CW.id]: { [channels.CONST__CH_1]: 227, [channels.CONST__CH_2]: 228 },
  [elements.REINDEER_JANE_WW.id]: { [channels.CONST__CH_1]: 225, [channels.CONST__CH_2]: 226 },
  [elements.REINDEER_JANE_MULTI.id]: { [channels.CONST__CH_1]: 223, [channels.CONST__CH_2]: 224 },

  [elements.FENCE_WARM_WHITE.id]: { [channels.CONST__CH_1]: [207, 27], [channels.CONST__CH_2]: [208,28] },
  [elements.FENCE_COOL_WHITE.id]: { [channels.CONST__CH_1]: [205, 29], [channels.CONST__CH_2]: [206, 30] },
  [elements.FENCE_MULTI.id]: { [channels.CONST__CH_1]: [209, 26], [channels.CONST__CH_2]: [210, 25] },

  [elements.PEPPERMINT_TREES.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  [elements.ELF_TREE_1.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  [elements.ELF_TREE_2.id]: { [channels.CONST__CH_1]: 98, [channels.CONST__CH_2]: 97 },
  // [elements.LETTERBOX.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },

  [elements.LETTERBOX_TREES_COOL_WHITE.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  [elements.LETTERBOX_TREES_WARM_WHITE.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  [elements.LETTERBOX_TREES_MULTI.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },

  [elements.TREE_WARM_WHITE.id]: { [channels.CONST__CH_1]: 1, [channels.CONST__CH_2]: 2 },
  [elements.TREE_MULTI.id]: { [channels.CONST__CH_1]: 3, [channels.CONST__CH_2]: 4 },
  [elements.TREE_COOL_WHITE.id]: { [channels.CONST__CH_1]: 5, [channels.CONST__CH_2]: 6 },

  [elements.MEGA_TREE_WARM_WHITE.id]: { [channels.CONST__CH_1]: 31, [channels.CONST__CH_2]: 32 },
  [elements.MEGA_TREE_COOL_WHITE.id]: { [channels.CONST__CH_1]: 33, [channels.CONST__CH_2]: 34 },
  [elements.MEGA_TREE_MULTI.id]: { [channels.CONST__CH_1]: 35, [channels.CONST__CH_2]: 36 },

  [elements.MEGA_TREE_STAR_MULTI.id]: { [channels.CONST__CH_1]: 19, [channels.CONST__CH_2]: 20 },
  [elements.MEGA_TREE_STAR_WARM.id]: { [channels.CONST__CH_1]: 23, [channels.CONST__CH_2]: 24 },
  [elements.MEGA_TREE_STAR_COOL.id]: { [channels.CONST__CH_1]: 21, [channels.CONST__CH_2]: 22 },

  // [elements.ROOF_MOUNTAIN_WARM_1.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.ROOF_MOUNTAIN_COOL.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.ROOF_MOUNTAIN_WARM_2.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },

  [elements.GUTTER_LINE_WARM.id]: { [channels.CONST__CH_1]: 15, [channels.CONST__CH_2]: 16 },
  [elements.GUTTER_LINE_COOL.id]: { [channels.CONST__CH_1]: 17, [channels.CONST__CH_2]: 18 },
  [elements.GUTTER_LINE_MULTI.id]: { [channels.CONST__CH_1]: 14, [channels.CONST__CH_2]: 13 },

  [elements.SANTA.id]: { [channels.CONST__CH_1]: 59, [channels.CONST__CH_2]: 60 },
  [elements.TRAIN.id]: { [channels.CONST__CH_1]: 55, [channels.CONST__CH_2]: 56 },
  [elements.MERRY_CHRISTMAS_SIGN.id]: { [channels.CONST__CH_1]: 57, [channels.CONST__CH_2]: 58 },

  [elements.RIBBON_BELLS.id]: { [channels.CONST__CH_1]: 127, [channels.CONST__CH_2]: 128 },
  [elements.BELLS.id]: { [channels.CONST__CH_1]: 137, [channels.CONST__CH_2]: 138 },
  [elements.PENGUINS.id]: { [channels.CONST__CH_1]: 191, [channels.CONST__CH_2]: null },
  [elements.STOCKINGS.id]: { [channels.CONST__CH_1]: 183, [channels.CONST__CH_2]: 184 },
  [elements.SNOWMAN.id]: { [channels.CONST__CH_1]: [78, 95], [channels.CONST__CH_2]: [96] },
  [elements.STANDING_KANGAROO.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: 79 },
  [elements.DUAL_BELLS_HOLLY.id]: { [channels.CONST__CH_1]: 81, [channels.CONST__CH_2]: null },
  [elements.DUAL_BELLS.id]: { [channels.CONST__CH_1]: 83, [channels.CONST__CH_2]: 84 },

  [elements.ROOF_OUTLINE_WARM.id]: { [channels.CONST__CH_1]: 9, [channels.CONST__CH_2]: 10 },
  [elements.ROOF_OUTLINE_COOL.id]: { [channels.CONST__CH_1]: 7, [channels.CONST__CH_2]: 8 },
  [elements.ROOF_OUTLINE_MULTI.id]: { [channels.CONST__CH_1]: 11, [channels.CONST__CH_2]: 12 },
  
  // [elements.SMALL_TREE.id]: { [channels.CONST__CH_1]: 181, [channels.CONST__CH_2]: 182 },

  // [elements.MINI_TREES_WW_1.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_W_1.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_WW_2.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_W_2.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_WW_3.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_W_3.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null },
  // [elements.MINI_TREES_WW_4.id]: { [channels.CONST__CH_1]: null, [channels.CONST__CH_2]: null }
};

// Using the hardcoded channel and element values above, swap the keys/values, such that the channel ID is the key, and
// the element ID is the value
/**
 * @var {{
 *    portId: {
 *      elementId,
 *      channel
 *    }
 *  }} elementsByPort
 * `portId` is the output port number for the controller
 * `elementId` is the string identifier for the element
 * `channel` is the first or second channel for the above element
 */
const elementsByPort = {};
const portsSeen = [];
Object.entries(portsByElement).forEach(([elementId, channels]) => {
  Object.entries(channels).forEach(([channel, port]) => {
    if (portsSeen.includes(port)) {
      // @TODO Come up with a better way to handle where there are ports re-used, and they're expected to be re-used
      console.warn(`Port ${port} used more than once`);
      // throw new Error(`Ports must only be referenced once. Port ${port} used more than once`);
    }
    if (port === 0) {
      throw new Error(`Port 0 needs to be replaced with the actual port number for ${elementId}`);
    }
    if (port !== null) {
      portsSeen.push(port);
    }
    // For elements that are spread out across the yard, they need to be connected to multiple ports, which means
    // in the data above, that element will have an array for the port numbers that is associated.
    // This will mainly in the House component for testing the lights.
    const portNumber = Array.isArray(port) ? port[0] : port;
    elementsByPort[portNumber] = {
      elementId,
      channel: Number.parseInt(channel, 10)
    };

    // If there are two ports, then make sure the other one gets set too.
    // I'm not sure if I'm actually using this anywhere but in the House component at the moment, and this likely
    // means that there will be 2 elements displayed in the House component, but I think that's an issue I should "fix"
    // in the House component itself, rather than messing with the data..
    if (Array.isArray(port)) {
      elementsByPort[port[1]] = {
        elementId,
        channel: Number.parseInt(channel, 10)
      };
    }
  });
});

module.exports = {
  byElement: portsByElement,
  byPort: elementsByPort
};
